import React from 'react';
import { useTranslation } from 'react-i18next';
import { useForm, useFormState } from 'react-final-form';
import { BUILDING_TYPE_ID } from '../../../../utils/helpers/constants';
import { FiltersSection } from './FiltersSection';
import { chipsStyles, FiltersOptionsWrapper } from './styled';
import { Chips } from '../../../ui/Chips';

const newOrSecondaryEstate = [
  {
    value: BUILDING_TYPE_ID.FLAT_NEW,
    name: 'new_search.new_building',
    id: 'new-search-form-new-building'
  },
  {
    value: BUILDING_TYPE_ID.FLAT_SECONDARY,
    name: 'new_search.secondary_building',
    id: 'new-search-form-second-hand-building'
  }
];

export const NewSearchNewOrSecondaryEstate = () => {
  const { t } = useTranslation();
  const { values } = useFormState();
  const { change } = useForm();

  const onNewChipClick = (id: string) => {
    change('category_id', id);
  };

  return (
    <FiltersSection title={t('search.form.building_type_group.title')}>
      <FiltersOptionsWrapper>
        {newOrSecondaryEstate.map(building => (
          <Chips
            text={t(building.name)}
            value={building.value}
            type="button"
            hasCustomOnChange
            key={building.id}
            storedValue={values.category_id}
            onClick={() => onNewChipClick(building.value)}
            styles={chipsStyles}
            stat={building.id}
          />
        ))}
      </FiltersOptionsWrapper>
    </FiltersSection>
  );
};
